import React, { FC, useContext, useEffect, useState } from 'react'
import { Button, message } from 'antd'
import { Row } from 'antd-v4'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { DigitalSignageCard } from './DigitalSignageCard'
import { inject } from 'mobx-react'
import { DeviceModal } from './DeviceModal'
import { LoadingAnimation } from '../../../../components/LoadingAnimation'
import { parseErrorMsg } from '../../../../utilities/helpers'
import {
  DigitalSignageDeleteMessage,
  DigitalSignageCardType,
  DigitalSignageAPIState,
} from './enums'
import { DigitalSignageContext } from './DigitalSignageContext'
import { SignageIds } from './type'
interface IDigitalSignagePageProps {
  currentCompanyStore?: CurrentCompanyStore
}
export interface IDigitalSignageDevice {
  deviceId: string
  deviceName: string
  expirationTime: number
  orientation: number
  pk: string
  retailerId: string
  shortCode: string
  signage?: SignageIds[]
  sk: string
  tenantId: string
}
export const DevicePage: FC<IDigitalSignagePageProps> = inject('currentCompanyStore')(
  ({ currentCompanyStore }) => {
    const [showDeviceModal, setShowDeviceModal] = useState(false)
    const locations = currentCompanyStore?.locations || []
    const company = currentCompanyStore?.company
    const [isEditing, setIsEditing] = useState(false)
    const [selectedDevice, setSelectedDevice] = useState<IDigitalSignageDevice | null>(null)
    const { status, getSignages, devices, getDevices, signages } = useContext(DigitalSignageContext)

    const getDigitalSignageDevices = async () => {
      if (company?.id.toString()) {
        getSignages(company?.id.toString())
        getDevices(company?.id.toString())
      }
    }
    useEffect(() => {
      try {
        getDigitalSignageDevices()
      } catch (error) {
        message.error(parseErrorMsg(error))
      }
    }, [])

    const handleCreateDevice = () => {
      setShowDeviceModal(true)
      setIsEditing(false)
    }
    const handleCustomizeDevice = (device: IDigitalSignageDevice) => {
      setShowDeviceModal(true)
      setIsEditing(true)
      if (device && device.signage && device?.signage.length > 0) {
        const updatedSignages = device.signage.filter((signage) => {
          const signageFound = signages.find((sig) => sig.id === signage.id)
          if (signageFound) {
            return signage
          }
        })
        setSelectedDevice({
          ...device,
          signage: updatedSignages,
        })
        return
      }
      setSelectedDevice(device)
    }
    return (
      <Row>
        <Button
          style={{ position: 'absolute', right: 0, zIndex: 1 }}
          type='primary'
          size='large'
          onClick={handleCreateDevice}
        >
          Register a new device
        </Button>
        <Row>
          {locations.map((location) => {
            const matchingDevices = devices.filter(
              (device) => device.retailerId === location.id.toString(),
            )
            return (
              <section
                key={location.id}
                className='pb-4 mb-4 card-wrapper'
                style={{ borderBottom: '1px solid rgba(0, 0, 0, .1)' }}
              >
                <h5 className='text-muted mb-4'>
                  <i className='fa fa-map-marker mr-2' aria-hidden='true' />
                  <span>{location.name}</span>
                </h5>
                <div className='d-flex flex-wrap'>
                  {status === DigitalSignageAPIState.FETCHING_DEVICES ? (
                    <LoadingAnimation />
                  ) : matchingDevices.length > 0 ? (
                    matchingDevices.map((device, index) => {
                      if (device.retailerId === location.id.toString()) {
                        return (
                          <DigitalSignageCard
                            key={index}
                            title={device.deviceName}
                            onButtonClick={() => handleCustomizeDevice(device)}
                            buttonText={'Customize'}
                            id={device.deviceId}
                            retailerId={location.id.toString()}
                            type={DigitalSignageCardType.DEVICE}
                            deleteMessage={DigitalSignageDeleteMessage.DELETE_DEVICE}
                          />
                        )
                      }
                    })
                  ) : (
                    <div className='text-muted'>
                      This location has no assigned digital signage devices.
                    </div>
                  )}
                </div>
              </section>
            )
          })}
        </Row>
        {showDeviceModal ? (
          <DeviceModal
            isOpen={showDeviceModal}
            isEditing={isEditing}
            device={selectedDevice}
            onClose={() => setShowDeviceModal(false)}
          />
        ) : null}
      </Row>
    )
  },
)
